import { render, staticRenderFns } from "./MoreInfoCardReseller.vue?vue&type=template&id=15a60d4e&scoped=true"
import script from "./MoreInfoCardReseller.vue?vue&type=script&lang=js"
export * from "./MoreInfoCardReseller.vue?vue&type=script&lang=js"
import style0 from "./MoreInfoCardReseller.vue?vue&type=style&index=0&id=15a60d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a60d4e",
  null
  
)

export default component.exports